<template>
  <div
    class="
      page-media
      main-page__block-media__container
    "
  >
    <media-content
      :component-settings="{
        caption: blockSettings.mediaCaption,
        layout: blockSettings.mediaLayout,
        hasControls: blockSettings.hasControls,
        hasContent: false,
        hasIndexLayout: false,
        autoplay: blockSettings.autoplay,
        loop: blockSettings.loop,
        muted: blockSettings.muted,
      }"
      block-class="page"
      :content-placement="blockSettings.mediaLayout"
      :mobile-media-settings="mobileMediaSettings"
      :desktop-media-settings="desktopMediaSettings"
      parent="page-media"
      @carousel-image-loaded="removePlaceholders"
    />
  </div>
</template>

<script>

/**
 * Vue: page media (page-media)
 * -----------------------------------------------------------------------------
 * Snippet for page media.
 *
 * @param {Object} blockSettings - Block settings.
 * @param {Object} mobileMediaSettings - Mobile media settings.
 * @param {Object} desktopMediaSettings - Desktop media settings.
 * @param {String} liquid.sectionId - Section's Liquid ID.
 */

import MediaContent from '~async/media-content/media-content'

export default {
  name: 'PageMedia',

  components: {
    MediaContent,
  },

  props: {
    blockSettings: {
      type: Object,
      default: () => ({
        mediaLayout: '',
        mediaCaption: '',
        hasControls: false,
        autoplay: true,
        loop: true,
        muted: true,
      }),
    },

    mobileMediaSettings: {
      type: Object,
      default: () => ({
        mobileDefaultHeight: true,
        mobileVideoFile: '',
        mobileVimeoId: '',
        mobileImage: '',
      }),
    },

    desktopMediaSettings: {
      type: Object,
      default: () => ({
        desktopDefaultHeight: true,
        desktopVideoFile: '',
        desktopVimeoId: '',
        desktopImage: '',
      }),
    },

    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
      }),
    },
  },

  mounted() {
    this.setNodeSelectors()
  },

  methods: {

    /**
     * Set node selectors.
     */
    setNodeSelectors() {
      this.nodeSelectors = {
        container: document.getElementById(`${this.liquid.sectionId}`),
      }
    },

    /**
     * Removes the liquid placeholders AFTER the vue media has loaded
     * and fully rendered.
     */
    removePlaceholders() {
      this.$nextTick().then(() => {
        const parent = this.nodeSelectors.container
        const placeholder = parent?.querySelector('.page-media-loaded')

        if (!placeholder) {
          return
        }

        placeholder.remove()
      })
    },
  },
}
</script>
